const meleeClipboardStorageKey = "melee_clipboard"

export interface PlayerClipboard {
    Player1 : string,
    Player2 : string,
    Player3 : string,
    Player4 : string
}

export const copyToClipboard = (names : string[]) => {
    let clipboardObject : PlayerClipboard = {
        Player1 : names[0],
        Player2 : names[1],
        Player3 : names[2],
        Player4 : names[3]
    };
    localStorage.setItem(meleeClipboardStorageKey, JSON.stringify(clipboardObject))
}

export const clipboardExists = () => {
    return localStorage.getItem(meleeClipboardStorageKey) !== null
}

export const pasteFromClipboard = () : PlayerClipboard => {
    if(clipboardExists()){
        const playerClipboard : PlayerClipboard = JSON.parse(String(localStorage.getItem(meleeClipboardStorageKey)))
        //ocalStorage.removeItem(meleeClipboardStorageKey);
        return playerClipboard;
    }
    throw new Error("Player Clipboard not found.")
}